import { useEffect, useRef } from "react";
import { useTour } from "@/components/tour/TourProvider";
import { autoStartTourId } from "@/components/tour/registry";

// Auto-starts the registered tour on first load. Waits for the tours fetch
// to resolve so a previously completed/skipped tour does not re-trigger.
export function TourAutoStarter({ activeTab }: { activeTab: string }) {
  const { progress, isProgressLoading, startTour, hasTour, activeTour } = useTour();
  const hasAutoStartedRef = useRef(false);

  useEffect(() => {
    if (hasAutoStartedRef.current) return;
    if (activeTour) return;
    if (isProgressLoading) return;
    const tourId = autoStartTourId(activeTab);
    if (!tourId || !hasTour(tourId)) return;
    const record = progress[tourId];
    if (record && (record.status === "completed" || record.status === "skipped")) {
      hasAutoStartedRef.current = true;
      return;
    }
    const t = window.setTimeout(() => {
      hasAutoStartedRef.current = true;
      startTour(tourId);
    }, 400);
    return () => window.clearTimeout(t);
  }, [progress, isProgressLoading, hasTour, startTour, activeTour, activeTab]);

  return null;
}
